export const updateAcceleratorInfo = (accelerator) => {
    return {
        type: 'UPDATE_ACCELERATOR_INFO',
        accelerator
    }
}